import React from 'react';
import { connect } from 'react-redux';
import { push, replace } from 'react-router-redux';

import { pathToMessages, pathToMessagesFolder } from 'Utils/nav/NavHelpers';
import { trackGAEvent, trackPageView, onPageView } from 'Actions/adsActions';
import { resetMessages, fetchMessages } from 'Actions/MessagesviewActions';
import messagesSelector from 'Selectors/messagesSelector';
import MessagePreviewList from 'Components/messages/MessagesPreviewListComponent';
import AdComponent from 'Components/ads/AdComponent';
import LoaderCss from 'Components/common/LoaderCssComponent';

import InfiniteScroll from 'Components/infiniteScroll/InfiniteScrollComponent';
import { resetInfinite } from 'Actions/InfiniteScrollActions';

class MessagesViewComponent extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			pmroute: 'pmfolder',
			id: null,
			headerHeight: 0
		};
	}

	componentWillMount() {
		this.setState({
			pmroute: 'pmfolder',
			id: this.props.params.folderId || null
		});
	}

	componentDidMount() {
		this.repositionScroll();
		let page = this.props.location.query.page || 1;
		this.props.dispatch( resetInfinite() );

		this.loadPage( parseInt( page ), true );
	}

	componentWillReceiveProps(nextProps) {
		let pmroute = 'pmfolder',
			id = nextProps.params.folderId || null;
		this.setState({
			id: id
		});

		let page = this.props.location.query.page || 1;

		if( parseInt( nextProps.params.folderId ) !== parseInt( this.props.params.folderId ) ) {
			this.props.dispatch( fetchMessages( {
				pmroute: pmroute,
				page: ( page ? parseInt( page ) : 1 ),
				id: id
			} ) );
		} else if( nextProps.messagesview.loaded && nextProps.messagesview.loaded !== this.props.messagesview.loaded ) {
			// trigger ad updates
			this.props.dispatch( onPageView() );
			// Record the Google Analytics pageview
			this.props.dispatch( trackPageView() );
		}
	}

	shouldComponentUpdate( nextProps, nextState ) {
		return (
			nextProps.messagesview.loaded !== this.props.messagesview.loaded ||
			nextProps.messagesview.isFetching !== this.props.messagesview.isFetching ||
			nextProps.messagesview.result.pms.length !== this.props.messagesview.result.pms.length ||
			nextProps.params.folderId !== this.props.params.folderId ||
			nextState.id !== this.state.id ||
			nextState.headerHeight !== this.state.headerHeight
		);
	}

	componentDidUpdate() {
		this.repositionScroll();

		// If we loaded and we have a pmid in the querystring, scroll to it
		if( this.props.messagesview.loaded && this.props.location.query.msgid ) {
			let folderLocation = {
					pathname: this.props.location.pathname,
					query: this.props.location.query.page ? { page: this.props.location.query.page } : null
				},
				pmContainer = document.getElementById( `pmpreview_${ this.props.location.query.msgid }` );

			if( pmContainer ) {
				window.scrollTo( 0, pmContainer.offsetTop - 15 );
			}
			// remove the pmid from the querystring
			this.props.dispatch( replace( folderLocation ) );
		}
	}

	loadPage = ( page, forceRefresh ) => {
		this.props.dispatch( fetchMessages( {
			pmroute: this.state.pmroute,
			page: ( page ? page : 1 ),
			id: this.state.id,
			forceRefresh: forceRefresh
		} ) );
	};

	goToFolder( folderId ) {
		if( isFinite( parseInt( folderId ) ) ) {
			this.props.dispatch(resetMessages());
			// Record the Google Analytics event.
			this.props.dispatch( trackGAEvent(false, 'backToMessagesFolder', 'uiAction', 'tap') );
			this.props.dispatch( push( pathToMessagesFolder( folderId ) ) );
		} else {
			this.props.dispatch(resetMessages());
			// Record the Google Analytics event.
			this.props.dispatch( trackGAEvent(false, 'backToMsgFolderList', 'uiAction', 'tap') );
			this.props.dispatch( push( pathToMessages() ) );
		}
	}

	repositionScroll = () => {
		if( this.header ) {
			let headerDim = this.header.getBoundingClientRect();

			if( headerDim.height && headerDim.height !== this.state.headerHeight ) {
				this.setState( { headerHeight: headerDim.height } );
			}
		}
	};

	getHeaderHeight = () => {
		let header = document.getElementById( 'header' );
		return header ? header.getBoundingClientRect().height : 0;
	};

	_getHeather() {
		const { result, total, totalPages, loaded, isFetching } = this.props.messagesview;
		let summary = total ?
			<div className="right list-summary">
				{ total.toLocaleString() } Message{ parseInt( total ) === 1 ? '' : 's' } / { totalPages.toLocaleString() } Page{ parseInt( totalPages ) === 1 ? '' : 's' }
			</div> : null,
			noResults = loaded && !isFetching && result.pms.length === 0 ? <div><h4>There are currently no messages within this folder.</h4></div> : null;
		return (
			<header className="thread topLink" ref={ ( h ) => this.header = h }>
				<span className="loadMore" onClick={ () => this.goToFolder() } >Return to Messages Folder List</span>
				{ summary }
				{ noResults }
			</header>
		);
	}

	render() {
		const { result, totalPages, loaded, isFetching } = this.props.messagesview;

		if( !loaded || ( result.pms && parseInt( result.pms ) === 0 && loaded ) ) {
			return <div className='messagesRoot messagesContainer'>{ this._getHeather() }<LoaderCss style={ { marginTop: this.state.headerHeight + 'px' } } /></div>;
		}

		let bottomAdUnit = <AdComponent adType="2" adName="Bottom_Content_Rectangle" />,
			items_list = result.pms.length > 0 ?
				<InfiniteScroll
					scrollRef={ i => this.infiniteScroll = i }
					totalPages={totalPages}
					isFetching={isFetching}
					loadPage={this.loadPage}
					location={this.props.location}
					extraHeaderHeight={ this.state.headerHeight }
				>
					<MessagePreviewList />
				</InfiniteScroll>
				: <div style={ { marginTop: this.state.headerHeight + this.getHeaderHeight() + 10 + 'px' } } />;

		return (
			<div className="messagesRoot messagesContainer">
				{ this._getHeather() }
				{ items_list  }
				{bottomAdUnit}
			</div>
		);
	}
}

export default connect( messagesSelector )( MessagesViewComponent );


// WEBPACK FOOTER //
// ./src/components/messages/MessagesFolderViewComponent.js